import {
    type GetHomepageThemeSettingApiResponse,
    type UpdateHomepageThemeApiRequest,
    type UpdateHomepageThemeApiResponse,
} from 'tradera/state/services/types/webapi-member-generated';
import { createApi } from '@reduxjs/toolkit/query/react';
import { isServer } from 'tradera/utils/nextjs';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';

export const startPageThemeApi = createApi({
    reducerPath: 'startPageThemeApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        updateHomepageTheme: builder.mutation<
            UpdateHomepageThemeApiResponse,
            UpdateHomepageThemeApiRequest
        >({
            query: (payload) => {
                const baseUrl = isServer ? '' : '/api/webapi';
                return {
                    url: `${baseUrl}/member/profile-homepage-theme`,
                    method: 'PUT',
                    body: payload,
                };
            },
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                const patchResult = dispatch(
                    startPageThemeApi.util.updateQueryData(
                        'getHomepageTheme',
                        undefined,
                        (theme) => {
                            Object.assign(theme, patch);
                        },
                    ),
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            },
        }),
        getHomepageTheme: builder.query<
            GetHomepageThemeSettingApiResponse,
            void
        >({
            query: () => {
                const baseUrl = isServer ? '' : '/api/webapi';
                return {
                    url: `${baseUrl}/member/profile-homepage-theme`,
                    method: 'GET',
                };
            },
        }),
    }),
});

export const {
    useUpdateHomepageThemeMutation,
    useGetHomepageThemeQuery,
    endpoints,
    util,
} = startPageThemeApi;
